import { Layout } from "antd";
import { Outlet } from "react-router-dom";

import { CartDrawer } from "@/components/Cart";
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";

const { Content } = Layout;

export const MainLayout = () => (
  <Layout style={{ minHeight: "100vh" }}>
    <Header />
    <Content className="page-shell">
      <Outlet />
    </Content>
    <Footer />
    <CartDrawer />
  </Layout>
);
